export default function DatenschutzPage() {
  return (
    <main className="pt-20 md:pt-24 bg-[#FDFCF8] min-h-screen" data-testid="datenschutz-page">
      <section className="py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <h1 className="font-serif text-3xl md:text-4xl font-medium text-[#2C332E] mb-8">
            Datenschutzerklärung
          </h1>
          
          <div className="prose prose-lg text-[#6B7280] space-y-8">
            <section>
              <h2 className="font-serif text-xl font-medium text-[#2C332E] mb-4">
                1. Datenschutz auf einen Blick
              </h2>
              <h3 className="font-medium text-[#2C332E] mb-2">Allgemeine Hinweise</h3>
              <p className="text-sm">
                Die folgenden Hinweise geben einen einfachen Überblick darüber, 
                was mit Ihren personenbezogenen Daten passiert, wenn Sie diese 
                Website besuchen. Personenbezogene Daten sind alle Daten, mit 
                denen Sie persönlich identifiziert werden können.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-xl font-medium text-[#2C332E] mb-4">
                2. Datenerfassung auf dieser Website
              </h2>
              <h3 className="font-medium text-[#2C332E] mb-2">
                Wer ist verantwortlich für die Datenerfassung?
              </h3>
              <p className="text-sm">
                Die Datenverarbeitung auf dieser Website erfolgt durch den 
                Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum 
                dieser Website entnehmen.
              </p>
              
              <h3 className="font-medium text-[#2C332E] mt-4 mb-2">
                Wie erfassen wir Ihre Daten?
              </h3>
              <p className="text-sm">
                Diese Website erfasst keine personenbezogenen Daten durch Formulare 
                oder Nutzerkonten. Es werden lediglich technisch notwendige Daten 
                durch den Hosting-Provider erhoben.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-xl font-medium text-[#2C332E] mb-4">
                3. Externe Links und Affiliate-Partner
              </h2>
              <p className="text-sm">
                Diese Website enthält Links zu externen Websites (Affiliate-Links). 
                Wenn Sie auf einen solchen Link klicken, werden Sie zu einer externen 
                Website weitergeleitet. Dort gelten die Datenschutzbestimmungen des 
                jeweiligen Anbieters. Wir haben keinen Einfluss auf die Datenerhebung 
                durch externe Websites.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-xl font-medium text-[#2C332E] mb-4">
                4. Cookies
              </h2>
              <p className="text-sm">
                Diese Website verwendet derzeit keine Cookies zur Analyse oder 
                Personalisierung. Technisch notwendige Cookies können durch den 
                Hosting-Provider gesetzt werden.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-xl font-medium text-[#2C332E] mb-4">
                5. Ihre Rechte
              </h2>
              <p className="text-sm">
                Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, 
                Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu 
                erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung 
                dieser Daten zu verlangen.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-xl font-medium text-[#2C332E] mb-4">
                6. Kontakt
              </h2>
              <p className="text-sm">
                Bei Fragen zum Datenschutz können Sie uns jederzeit unter 
                kontakt@eidgeschenke.de kontaktieren.
              </p>
            </section>
          </div>

          <div className="mt-12 p-6 rounded-2xl bg-[#F5F5F0]">
            <p className="text-sm text-[#6B7280]">
              <strong className="text-[#2C332E]">Hinweis:</strong> Dies ist eine 
              MVP-Version der Website. Die vollständige Datenschutzerklärung wird 
              vor dem offiziellen Launch erstellt und an die geltenden Anforderungen 
              angepasst.
            </p>
          </div>
        </div>
      </section>
    </main>
  );
}
